import { Component, OnInit } from '@angular/core';
import { Title} from '@angular/platform-browser';


@Component({
  selector: 'app-about-us',
  templateUrl: './about-us.component.html',
  styleUrls: ['./about-us.component.css']
})
export class AboutUsComponent implements OnInit {

  constructor(private titleService: Title) { }

  ngOnInit() {

    this.titleService.setTitle('About Vervendo' + ' ' + '|' + ' ' +  'Vervendo.com');
    this.hideHeader();
    this.hideBookInfo();
    this.hideVillaName();
  }
  hideHeader() {

    const x = document.getElementById('headerSorting');

    if (x) {

      x.style.display = 'none';
    }
  }

  hideBookInfo() {
    const w = document.getElementById('bookInfo');
    if (w) {
        w.style.visibility = 'hidden';
    }
}

hideVillaName() {
  const r = document.getElementById('headerSortig');
  if (r) {
      r.style.visibility = 'hidden';
  }
}
}
